var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',{staticClass:"h100"},[_c('v-col',{staticClass:"pa-0",attrs:{"cols":"auto"}},[_c('SideBar')],1),_c('v-col',{attrs:{"xs":"12"}},[_c('v-row',{staticClass:"mb-5 h5"},[_c('Header')],1),_c('router-view',{key:_vm.$route.fullPath})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }